import Axios from 'axios';
import { Message,Loading } from 'element-ui'
import { removeToken } from '@/utils/auth'
import { tansParams, blobValidate } from "@/utils/commonUtils";
import { saveAs } from 'file-saver'
import { getToken } from '@/utils/auth'
import { getBaseUrl,setBaseUrl} from '@/utils/auth'
// import Router from '@/router'
// import config from '@/assets/config'
// import { getLocalStorage } from "@/utils/index"
// import {Toast} from 'vant'
let https;
let downloadLoadingInstance;
// downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
// const baseURL = getBaseUrl();
https = Axios.create({
  // baseURL:"http://192.168.22.227:9100",
  baseURL:'https://www.cnxz.com.cn/prod-api',
  // baseURL:'/api',
  responseType: "json",
  timeout: 60000,
  // methods: "post",
  headers: {
    "Content-Type": "application/json"
    // "Content-Type": 'application/x-www-form-urlencoded; charset=UTF-8'
  },
  transformRequest: [function (data) {
    return JSON.stringify(data);
  }]
});

https.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  // downloadLoadingInstance.close();
  return Promise.reject(new Error('error info'))
  // return Promise.reject(error);
});

https.interceptors.response.use(function (ret) {
  if(ret.data.code == 401){
    Message({
      message: '无效的会话，或者会话已过期，请重新登录',
      type: 'error'
    })
    // downloadLoadingInstance.close();
    // location.reload();
    removeToken();
    // return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
  }
  if(ret.data.code == 200){
    // downloadLoadingInstance.close();
  }
  // downloadLoadingInstance.close();
  return ret.data;
}, function (err) {
  // downloadLoadingInstance.close();
  Message({
    message: '网络异常',
    type: 'error'
  })
  // Toast('网络异常');
  return Promise.reject(new Error('error info'))
  // return Promise.reject(err.response);
});

// 通用下载方法
export function download(url, params, filename) {
  console.log('rul:',url)
  // return;
  // downloadLoadingInstance = Loading.https({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
  https.post(baseURL+url, params, {
    transformRequest: [(params) => { return tansParams(params) }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'access-token': "sjxz "+getToken()
    },
    responseType: 'blob'
  }).then(async (data) => {
    const blob = new Blob([data])
    saveAs(blob, filename)
    return;
    const isLogin = await blobValidate(data);
    if (isLogin) {

    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      // const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      Message.error(errMsg);
    }
    // downloadLoadingInstance.close();
  }).catch((r) => {
    console.error(r)
    Message.error('下载文件出现错误，请联系管理员！')
    // downloadLoadingInstance.close();
  })
}
export default https;

/******************************************************************
 * 函数名: httpServer
 * 功能: 简化axios
 * 参数: url(String)访问的路径
 *      methods(String/[get|post]) 访问的方法
 *      DATA(Object)传给后台的参数
 * 返回值: 无
 * Author: LF
 ******************************************************************/
export function httpServer(url, DATA,token) {
  https.post({
    url: url,
    data: DATA
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/request.js